var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortBy = function SvgSortBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M3.063 9.938a.438.438 0 0 1-.876 0V2.244L1.185 3.247a.438.438 0 0 1-.618-.619L2.315.878 2.32.873a.436.436 0 0 1 .613.006l1.75 1.75a.438.438 0 0 1-.618.619L3.063 2.244zM6.125 2.063c0-.242.196-.438.438-.438h6.125a.438.438 0 0 1 0 .875H6.562a.44.44 0 0 1-.437-.437M6.563 4.25a.438.438 0 0 0 0 .875h4.375a.438.438 0 0 0 0-.875zM6.563 6.875a.438.438 0 0 0 0 .875h2.625a.438.438 0 0 0 0-.875zM6.563 9.5a.438.438 0 0 0 0 .875h.875a.438.438 0 0 0 0-.875z"
  })));
};
export default SvgSortBy;